import { render, staticRenderFns } from "./Tambah.vue?vue&type=template&id=73a7a2a0&scoped=true&"
import script from "./Tambah.vue?vue&type=script&lang=js&"
export * from "./Tambah.vue?vue&type=script&lang=js&"
import style0 from "./Tambah.vue?vue&type=style&index=0&id=73a7a2a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a7a2a0",
  null
  
)

export default component.exports